import React, {Component} from 'react'

import PaperBlock from "../../ui/PaperBlock"
import TextField from '@material-ui/core/TextField'

/**
 * <SearchPanel onChange = {searchString} />
 */

class SearchPanel extends Component {

	state = {
		searchString: ""
	}

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<TextField
				style = {{flex: "1 1 auto"}}
				label = "Поиск"
				value = {this.state.searchString}
				onChange={e => {
					this.setState({ searchString: e.target.value },  () => {
						this.lastEnterTime = new Date().getTime()
						if (!this.intervalId) {
							this.intervalId = setInterval(() => {
								if (this.lastEnterTime + 300 < new Date().getTime()) {
									clearInterval(this.intervalId)
									this.intervalId = undefined
									if (typeof this.props.onChange === "function") {
										this.props.onChange(this.state.searchString)
									}
								}
							}, 200)
						}
					})
				}}
			/>

		</PaperBlock>

	}

}

export default SearchPanel
